import Axios from 'axios';

const BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8080/api/';

export const slugify = (text) => {
  if (!text) return '';
  return text
    .toString()
    .toLowerCase()
    .trim()
    .replace(/\s+/g, '-')
    .replace(/[^\w\-]+/g, '')
    .replace(/\-\-+/g, '-')
    .replace(/^-+/, '')
    .replace(/-+$/, '');
};

export const saveDesign = async (data, name) => {
  try {
    const response = await Axios.post(`${BASE_URL}user/savetemplate`, {
      data: JSON.stringify(data.design),
      tag: name,
      htmlData: data.html.toString(),
    });
    if (response.status.toString().startsWith('2')) {
      return response;
    } else {
      return false;
    }
  } catch (err) {
    console.log(err);
    return false;
  }
};

// NEWS ADMIN APIS
export const fetchNews = async () => {
  try {
    const response = await Axios.get(`${BASE_URL}news/getAll`, {
      headers: {
        Authorization: localStorage.getItem('admin_token') || '',
      },
    });
    return response.data?.news || [];
  } catch (err) {
    console.log(err);
    return [];
  }
};

export const createNews = async ({ title, description, imageUrl, imageKey, link, date }) => {
  try {
    const response = await Axios.post(
      `${BASE_URL}news/create`,
      { title, description, imageUrl, imageKey, link, date },
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: localStorage.getItem('admin_token') || '',
        },
      }
    );
    return response.status.toString().startsWith('2');
  } catch (err) {
    console.log(err);
    return false;
  }
};

export const updateNews = async ({ id, title, description, imageUrl, imageKey, link, date }) => {
  try {
    const response = await Axios.post(
      `${BASE_URL}news/update`,
      { id, title, description, imageUrl, imageKey, link, date },
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: localStorage.getItem('admin_token') || '',
        },
      }
    );
    return response.status.toString().startsWith('2');
  } catch (err) {
    console.log(err);
    return false;
  }
};

export const deleteNews = async ({ id }) => {
  try {
    const response = await Axios.post(
      `${BASE_URL}news/delete`,
      { id },
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: localStorage.getItem('admin_token') || '',
        },
      }
    );
    return response.status.toString().startsWith('2');
  } catch (err) {
    console.log(err);
    return false;
  }
};

export const uploadNewsImage = async (file) => {
  try {
    const presignedResponse = await Axios.post(
      `${BASE_URL}news/generateUploadUrl`,
      { file: file.type },
      {
        headers: {
          Authorization: localStorage.getItem('admin_token') || '',
        },
      }
    );

    const { uploadUrl, key } = presignedResponse.data;

    await Axios.put(uploadUrl, file, {
      headers: {
        'Content-Type': file.type,
      },
    });

    const imageUrl = uploadUrl.split('?')[0];
    return { url: imageUrl, key };
  } catch (err) {
    console.log(err);
    return { url: '', key: '' };
  }
};

export const deleteNewsImage = async (key) => {
  try {
    const response = await Axios.post(
      `${BASE_URL}news/deleteImage`,
      { key },
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: localStorage.getItem('admin_token') || '',
        },
      }
    );
    return response.status.toString().startsWith('2');
  } catch (err) {
    console.log(err);
    return false;
  }
};

export const updateDesign = async ({ id, design, name, html }) => {
  try {
    const response = await Axios.post(`${BASE_URL}user/updatetemplate`, {
      id: id,
      data: JSON.stringify(design),
      tag: name,
      htmlData: html.toString(),
    });
    return response.status.toString().startsWith('2');
  } catch (err) {
    console.log(err);
    return false;
  }
};

export const testEmailApi = async ({ emails, tag, subject }) => {
  try {
    const body = {
      emails,
      mailOptions: {
        subject,
      },
      tag,
    };
    const response = await fetch(`${BASE_URL}user/testEmail`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(body),
    });
    return response.status.toString().startsWith('2');
  } catch (err) {
    console.log(err);
  }
};

export const fetchDesign = async () => {
  try {
    const response = await fetch(`${BASE_URL}user/gettemplate`, {
      method: 'GET',
    });
    const resp = await response.json();
    if (response.status.toString().startsWith('2')) {
      return resp;
    } else {
      return false;
    }
  } catch (err) {
    console.log(err);
    return false;
  }
};

export const searchEmployer = async (searchText) => {
  try {
    const response = await fetch(
      `${BASE_URL}employee/getemployee?ent_key=${searchText}`,
      {
        method: 'GET',
      }
    );
    if (response.status.toString().startsWith('2')) {
      const { employees } = await response.json();
      return employees;
    } else {
      return false;
    }
  } catch (err) {
    console.log(err);
  }
};

export const getUsers = async ({ selected, ein }) => {
  try {
    const response = await fetch(
      `${BASE_URL}user/getusersforemail?selected=${selected}&ein=${ein}`,
      {
        method: 'GET',
      }
    );
    if (response.status.toString().startsWith('2')) {
      const { users } = await response.json();
      return users;
    } else {
      return false;
    }
  } catch (err) {
    console.log(err);
  }
};

export const getNewsletterSubscribers = async () => {
  try {
    const response = await fetch(`${BASE_URL}newsletter/getSubscribers`, {
      method: 'GET',
      headers: {
        Authorization: localStorage.getItem('admin_token') || '',
      },
    });
    if (response.status.toString().startsWith('2')) {
      const { subscribers } = await response.json();
      return subscribers;
    } else {
      return [];
    }
  } catch (err) {
    console.log(err);
    return [];
  }
};

export const emailUsers = async ({
  all,
  partial,
  users,
  ein,
  subject,
  tag,
}) => {
  const selectedStr = all ? 'ALL' : 'NOTALL';
  const normalizedUsers = Array.isArray(users)
    ? Array.from(
        new Set(
          users
            .map((u) => {
              if (typeof u === 'string') return u;
              if (u && typeof u === 'object' && typeof u.email === 'string') return u.email;
              return '';
            })
            .map((e) => (typeof e === 'string' ? e.trim() : ''))
            .filter((e) => e && e.includes('@'))
        )
      )
    : [];
  const isPartial = selectedStr === 'NOTALL' && normalizedUsers.length > 0;
  const body = {
    partial: isPartial,
    selected: selectedStr,
    ein: ein,
    mailOptions: {
      subject: subject,
    },
    users: selectedStr === 'NOTALL' ? normalizedUsers : [],
    tag: tag,
  };
  try {
    const response = await fetch(`${BASE_URL}user/sendSelectedEmail`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: localStorage.getItem('admin_token') || '',
      },
      body: JSON.stringify(body),
    });
    return response.status.toString().startsWith('2');
  } catch (err) {
    console.log(err);
    return false;
  }
};

// BLOG ADMIN APIS
export const fetchBlogs = async () => {
  try {
    const response = await Axios.get(`${BASE_URL}blog/getAll`, {
      headers: {
        Authorization: localStorage.getItem('admin_token') || '',
      },
    });
    return response.data?.blogs || [];
  } catch (err) {
    console.log(err);
    return [];
  }
};

export const createBlog = async ({ heading, description, imageUrl, imageKey, youtubeUrl, slug, scheduledAt, status }) => {
  try {
    const response = await Axios.post(
      `${BASE_URL}blog/create`,
      { heading, description, imageUrl, imageKey, youtubeUrl, slug, scheduledAt, status },
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: localStorage.getItem('admin_token') || '',
        },
      }
    );
    return response.data || response.status.toString().startsWith('2');
  } catch (err) {
    console.log(err);
    return false;
  }
};

export const updateBlog = async ({ id, heading, description, imageUrl, imageKey, youtubeUrl, slug, scheduledAt, status }) => {
  try {
    const response = await Axios.post(
      `${BASE_URL}blog/update`,
      { id, heading, description, imageUrl, imageKey, youtubeUrl, slug, scheduledAt, status },
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: localStorage.getItem('admin_token') || '',
        },
      }
    );
    return response.status.toString().startsWith('2');
  } catch (err) {
    console.log(err);
    return false;
  }
};

export const getChallengeRegistrations = async () => {
  try {
    const response = await fetch(`${BASE_URL}challenge/admin/list`, {
      method: 'GET',
      headers: {
        Authorization: localStorage.getItem('admin_token') || '',
      },
    });
    if (response.status.toString().startsWith('2')) {
      const { registrations } = await response.json();
      return registrations || [];
    }
    return [];
  } catch (err) {
    console.log(err);
    return [];
  }
};

export const exportChallengeRegistrationsCsv = async () => {
  try {
    const response = await fetch(`${BASE_URL}challenge/admin/export`, {
      method: 'GET',
      headers: {
        Authorization: localStorage.getItem('admin_token') || '',
      },
    });
    if (response.status.toString().startsWith('2')) {
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'challenge_registrations.csv';
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
      return true;
    }
    return false;
  } catch (err) {
    console.log(err);
    return false;
  }
};

export const deleteBlog = async ({ id }) => {
  try {
    const response = await Axios.post(
      `${BASE_URL}blog/delete`,
      { id },
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: localStorage.getItem('admin_token') || '',
        },
      }
    );
    return response.status.toString().startsWith('2');
  } catch (err) {
    console.log(err);
    return false;
  }
};

export const uploadBlogImage = async (file) => {
  try {
    // 1. Get pre-signed URL
    const presignedResponse = await Axios.post(
      `${BASE_URL}blog/generateUploadUrl`,
      { file: file.type },
      {
        headers: {
          Authorization: localStorage.getItem('admin_token') || '',
        },
      }
    );

    const { uploadUrl, key } = presignedResponse.data;

    // 2. Upload file to S3
    await Axios.put(uploadUrl, file, {
      headers: {
        'Content-Type': file.type,
      },
    });

    const imageUrl = uploadUrl.split('?')[0];
    return { url: imageUrl, key };
  } catch (err) {
    console.log(err);
    return { url: '', key: '' };
  }
};

export const deleteBlogImage = async (key) => {
  try {
    const response = await Axios.post(
      `${BASE_URL}blog/deleteImage`,
      { key },
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: localStorage.getItem('admin_token') || '',
        },
      }
    );
    return response.status.toString().startsWith('2');
  } catch (err) {
    console.log(err);
    return false;
  }
};

export const fetchBlog = async (idOrSlug) => {
  try {
    // 1. Try numeric ID
    if (/^\d+$/.test(String(idOrSlug))) {
      const response = await Axios.get(`${BASE_URL}blog/get`, {
        params: { id: idOrSlug },
        headers: {
          Authorization: localStorage.getItem('admin_token') || '',
        },
      });
      return response.data?.blog || null;
    }

    // 2. Try slug directly
    try {
      const response = await Axios.get(`${BASE_URL}blog/get`, {
        params: { slug: idOrSlug },
        headers: {
          Authorization: localStorage.getItem('admin_token') || '',
        },
      });
      if (response.data?.blog) return response.data.blog;
    } catch (e) {
      // Ignore
    }

    // 3. Fallback: Find in getAll
    const response = await Axios.get(`${BASE_URL}blog/getAll`, {
      headers: {
        Authorization: localStorage.getItem('admin_token') || '',
      },
    });
    const blogs = response.data?.blogs || [];
    const match = blogs.find(b => {
      const s = b.slug || slugify(b.heading);
      return s === idOrSlug;
    });

    if (match?.id) {
      const detail = await Axios.get(`${BASE_URL}blog/get`, {
        params: { id: match.id },
        headers: {
          Authorization: localStorage.getItem('admin_token') || '',
        },
      });
      return detail.data?.blog || null;
    }
    return null;
  } catch (err) {
    console.log(err);
    return null;
  }
};

export const updateBlogContent = async ({ id, content }) => {
  try {
    const response = await Axios.post(
      `${BASE_URL}blog/updateContent`,
      { id, content },
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: localStorage.getItem('admin_token') || '',
        },
      }
    );
    return response.status.toString().startsWith('2');
  } catch (err) {
    console.log(err);
    return false;
  }
};

// NEWSLETTER ADMIN APIS
export const fetchNewsletters = async () => {
  try {
    const response = await Axios.get(`${BASE_URL}newsletter/getAll`, {
      headers: {
        Authorization: localStorage.getItem('admin_token') || '',
      },
    });
    return response.data?.newsletters || [];
  } catch (err) {
    console.log(err);
    return [];
  }
};

export const createNewsletter = async ({ heading, description, imageUrl, imageKey, source, slug }) => {
  try {
    const response = await Axios.post(
      `${BASE_URL}newsletter/create`,
      { heading, description, imageUrl, imageKey, source, slug },
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: localStorage.getItem('admin_token') || '',
        },
      }
    );
    return response.status.toString().startsWith('2');
  } catch (err) {
    console.log(err);
    return false;
  }
};

export const updateNewsletter = async ({ id, heading, description, imageUrl, imageKey, source, slug }) => {
  try {
    const response = await Axios.post(
      `${BASE_URL}newsletter/update`,
      { id, heading, description, imageUrl, imageKey, source, slug },
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: localStorage.getItem('admin_token') || '',
        },
      }
    );
    return response.status.toString().startsWith('2');
  } catch (err) {
    console.log(err);
    return false;
  }
};

export const deleteNewsletter = async ({ id }) => {
  try {
    const response = await Axios.post(
      `${BASE_URL}newsletter/delete`,
      { id },
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: localStorage.getItem('admin_token') || '',
        },
      }
    );
    return response.status.toString().startsWith('2');
  } catch (err) {
    console.log(err);
    return false;
  }
};

export const uploadNewsletterImage = async (file) => {
  try {
    // 1. Get pre-signed URL
    const presignedResponse = await Axios.post(
      `${BASE_URL}newsletter/generateUploadUrl`,
      { file: file.type },
      {
        headers: {
          Authorization: localStorage.getItem('admin_token') || '',
        },
      }
    );

    const { uploadUrl, key } = presignedResponse.data;

    // 2. Upload file to S3
    await Axios.put(uploadUrl, file, {
      headers: {
        'Content-Type': file.type,
      },
    });

    const imageUrl = uploadUrl.split('?')[0];
    return { url: imageUrl, key };
  } catch (err) {
    console.log(err);
    return { url: '', key: '' };
  }
};

export const deleteNewsletterImage = async (key) => {
  try {
    const response = await Axios.post(
      `${BASE_URL}newsletter/deleteImage`,
      { key },
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: localStorage.getItem('admin_token') || '',
        },
      }
    );
    return response.status.toString().startsWith('2');
  } catch (err) {
    console.log(err);
    return false;
  }
};

export const fetchNewsletter = async (idOrSlug) => {
  try {
    // 1. Try numeric ID
    if (/^\d+$/.test(String(idOrSlug))) {
      const response = await Axios.get(`${BASE_URL}newsletter/get`, {
        params: { id: idOrSlug },
        headers: {
          Authorization: localStorage.getItem('admin_token') || '',
        },
      });
      return response.data?.newsletter || null;
    }

    // 2. Try slug directly
    try {
      const response = await Axios.get(`${BASE_URL}newsletter/get`, {
        params: { slug: idOrSlug },
        headers: {
          Authorization: localStorage.getItem('admin_token') || '',
        },
      });
      if (response.data?.newsletter) return response.data.newsletter;
    } catch (e) {
      // Ignore
    }

    // 3. Fallback
    const response = await Axios.get(`${BASE_URL}newsletter/getAll`, {
      headers: {
        Authorization: localStorage.getItem('admin_token') || '',
      },
    });
    const newsletters = response.data?.newsletters || [];
    const match = newsletters.find(n => {
      const s = n.slug || slugify(n.heading);
      return s === idOrSlug;
    });

    if (match?.id) {
      const detail = await Axios.get(`${BASE_URL}newsletter/get`, {
        params: { id: match.id },
        headers: {
          Authorization: localStorage.getItem('admin_token') || '',
        },
      });
      return detail.data?.newsletter || null;
    }
    return null;
  } catch (err) {
    console.log(err);
    return null;
  }
};

export const updateNewsletterContent = async ({ id, content }) => {
  try {
    const response = await Axios.post(
      `${BASE_URL}newsletter/updateContent`,
      { id, content },
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: localStorage.getItem('admin_token') || '',
        },
      }
    );
    return response.status.toString().startsWith('2');
  } catch (err) {
    console.log(err);
    return false;
  }
};
